import { IconButton } from "@mui/material"
import { MdMyLocation, MdNearMe } from "react-icons/md"

import { abrirVagaNoGps } from "../../../servicos/gestaoVagaGps"
import {
	isMotivoProximidade,
	resolverMotivoTipo,
	textoDistanciaVagaFila,
	textoLimiteRaioFila,
} from "./gestaoVagaFilaUi.js"

/**
 * GPS / proximidade — o que falta para entrar na fila.
 */
export default function GestaoVagaFilaAlertaProximidade({
	vaga,
	compacto = false,
	onAtualizarLocalizacao,
	atualizandoGeo = false,
	onErroGps,
}) {
	if (!vaga || !isMotivoProximidade(vaga)) return null

	const semGeo = resolverMotivoTipo(vaga) === "sem_geo"
	const distancia = textoDistanciaVagaFila(vaga)
	const limiteRaio = textoLimiteRaioFila(vaga)

	return (
		<div
			className={`gv-fila-alerta-prox${compacto ? " gv-fila-alerta-prox--compact" : ""}`}
			role="alert"
		>
			<div className="gv-fila-alerta-prox__corpo">
				<span className="gv-fila-alerta-prox__icone" aria-hidden>
					{semGeo ? <MdMyLocation size={24} /> : <MdNearMe size={24} />}
				</span>
				<div className="gv-fila-alerta-prox__textos">
					<strong className="gv-fila-alerta-prox__titulo">
						{semGeo ? "Ative o GPS" : "Chegue mais perto"}
					</strong>
					<p className="gv-fila-alerta-prox__msg m-0">
						{semGeo
							? "Precisamos da sua localização para entrar na fila."
							: "Você precisa estar dentro do raio da vaga para entrar na fila."}
					</p>
					{!semGeo && distancia ? (
						<p className="gv-fila-alerta-prox__dist m-0">{distancia}</p>
					) : null}
					{!semGeo && limiteRaio ? (
						<p className="gv-fila-alerta-prox__limite m-0">{limiteRaio}</p>
					) : null}
				</div>
			</div>
			<div className="gv-fila-alerta-prox__acoes">
				{semGeo && onAtualizarLocalizacao ? (
					<button
						type="button"
						className="btnFullW gv-fila-alerta-prox__btn"
						disabled={atualizandoGeo}
						onClick={onAtualizarLocalizacao}
					>
						<MdMyLocation size={18} aria-hidden />
						{atualizandoGeo ? "Atualizando…" : "Atualizar GPS"}
					</button>
				) : null}
				{!semGeo ? (
					<button
						type="button"
						className="btnFullW gv-fila-alerta-prox__btn gv-fila-alerta-prox__btn--gps"
						onClick={() => {
							if (!abrirVagaNoGps(vaga)) {
								onErroGps?.("Não foi possível abrir a vaga no mapa.")
							}
						}}
					>
						<MdNearMe size={18} aria-hidden />
						Abrir no mapa
					</button>
				) : null}
				{!semGeo && onAtualizarLocalizacao ? (
					<IconButton
						type="button"
						size="small"
						className="gv-fila-alerta-prox__geo-mini"
						aria-label="Atualizar localização"
						title="Atualizar GPS"
						disabled={atualizandoGeo}
						onClick={onAtualizarLocalizacao}
					>
						<MdMyLocation size={20} />
					</IconButton>
				) : null}
			</div>
		</div>
	)
}
